import React from 'react';
import {Grid, Text} from '@tenancy.nz/ui';
import ListingPartnerCard from './ListingPartnerCard';
import allhouseLogo from '../assets/partner-allhouse.png';
import oneroofLogo from '../assets/partner-oneroof.svg';
import realestateLogo from '../assets/partner-realestate.svg';

const PARTNERS = [
  {
    name: 'Allhouse',
    tagline: 'Redefining living',
    logo: allhouseLogo,
    href: 'https://allhouse.co.nz',
    cta: 'Visit now',
    ctaColor: '#000222',
  },
  {
    name: 'OneRoof',
    tagline: 'Property in your pocket',
    logo: oneroofLogo,
    href: 'https://www.oneroof.co.nz',
    cta: 'Download the app',
    ctaColor: '#e66b00',
  },
  {
    name: 'realestate.co.nz',
    tagline: 'It all starts here',
    logo: realestateLogo,
    href: 'https://www.realestate.co.nz',
    cta: 'Download the app',
    ctaColor: '#0203a3',
  },
];

function ListingPartners() {
  return (
    <>
      <Text paragraph sx={{mb: 8}}>
        Tenant.co.nz is fully integrated with New Zealand&#39;s leading rental
        listing platforms. To check out more rental listings, click below:
      </Text>
      <Grid container spacing={8} alignItems="stretch">
        {PARTNERS.map(partner => (
          <Grid item xs={12} sm={6} md={4} key={partner.name}>
            <ListingPartnerCard {...partner} />
          </Grid>
        ))}
      </Grid>
    </>
  );
}

export default ListingPartners;
